import React, { useEffect } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Container, Row, Col, Spinner } from "react-bootstrap";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchProductDetails } from "../../redux/slices/productDetailsSlice";
import productImg from "../../assets/images/card-img.jpg";
import dirham from "../../assets/images/dirham.png";

const ProductInfo = () => {
  const { id } = useParams(); 
  const dispatch = useDispatch();
  const { product, loading, error } = useSelector(
    (state) => state.productDetails
  );

  const [nav1, setNav1] = React.useState(null);
  const [nav2, setNav2] = React.useState(null);

  useEffect(() => {
    if (id) dispatch(fetchProductDetails(id));
  }, [dispatch, id]);

  const mainSettings = {
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    asNavFor: nav2,
    adaptiveHeight: true,
  };

  const thumbSettings = {
    slidesToShow: 5,
    slidesToScroll: 1,
    asNavFor: nav1,
    focusOnSelect: true,
    swipeToSlide: true,
    arrows: true,
    vertical: true,
    verticalSwiping: true,
    centerMode: false,
  };

  if (loading)
    return (
      <div className="text-center py-5">
        <Spinner animation="border" />
      </div>
    );

  if (error)
    return (
      <div className="text-center py-5 text-danger">
        <p>{error}</p>
      </div>
    );

  if (!product) return null;

  const images = product.image_url ? [product.image_url] : [productImg];
  const stock =
    (product.prod_stockqty1 || 0) +
    (product.Prod_stockqty2 || 0) +
    (product.Prod_stockqty3 || 0);

  return (
    <section className="productinfo-section">
      <Container>
        <Row>
          <Col lg={6} md={12} >
            <div className="productimg-slider">
              <Row>
                <Col lg={2} md={12}>
                  <Slider
                    {...thumbSettings}
                    asNavFor={nav1}
                    ref={(slider) => setNav2(slider)}
                    className="thumb-slider"
                  >
                    {images.map((img, i) => (
                      <div key={i}>
                        <img src={img} alt={`thumb-${i}`} className="thumb-img" />
                      </div>
                    ))}
                  </Slider>
                </Col>
                <Col lg={10} md={12}>
                  <Slider
                    {...mainSettings}
                    asNavFor={nav2}
                    ref={(slider) => setNav1(slider)}
                    className="main-slider"
                  >
                    {images.map((img, i) => (
                      <div key={i}>
                        <img src={img} alt={`slide-${i}`} className="main-img" />
                      </div>
                    ))}
                  </Slider>
                </Col>
              </Row>
            </div>
          </Col>

          <Col lg={6} md={12} >
            <div className="productinfo-content">
              <h3 className="productinfo-title">{product.PROD_NAME}</h3>
              <p className="productinfo-description">{product.PROD_DESC}</p>

              <div className="stockprice-info">
                <div className="stock-info">
                  <h5>In Stock :</h5>
                  <p>{stock} PCS</p>
                </div>
                <div className="price-info stock-info">
                  <h5>Price :</h5>
                  <div className="d-flex align-items-center gap-1">
                    <p>{product.PROD_SP1}</p>
                    <img src={dirham} alt="dirham" loading="lazy" />
                  </div>
                </div>
              </div>

              <ul className="productinfo-list">
                <li>
                  <h5>Barcode</h5>
                  <p>{product.PROD_BARCODE}</p>
                </li>
                <li>
                  <h5>Unit Cost</h5>
                  <p>{product.PROD_MSP}</p>
                </li>
                <li>
                  <h5>MSP</h5>
                  <p>{product.PROD_MSP}</p>
                </li>
                <li>
                  <h5>SP1</h5>
                  <p>{product.PROD_SP1}</p>
                </li>
                <li>
                  <h5>SP2</h5>
                  <p>{product.PROD_SP2}</p>
                </li>
              </ul>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default ProductInfo;
